/* eslint-disable i18n-scan/no-inline-content */
// External Modules
import React from 'react';

// Internal Modules

import { FullNameLabel } from './StyledComponents';

import { getContent } from '@/lib';
// @ts-expect-error TODO:@checkout/react-components
import { FullName } from '@checkout/react-components';
import { useStoreState } from '@/store';
import { formInputHandlers } from '@/components/Form/formInputHandlers';

import { CountryCodes } from '@/generated/graphql';

export const KanaAndKanjiNames = (): JSX.Element => {
  const firstName = useStoreState(({ form }) => form.firstName);
  const lastName = useStoreState(({ form }) => form.lastName);
  const onboardOption = useStoreState(({ form }) => form.onboardOption);

  const countrySpecificFirstName = useStoreState(
    ({ form }) => form.countrySpecificFirstName,
  );
  const countrySpecificLastName = useStoreState(
    ({ form }) => form.countrySpecificLastName,
  );
  const nationality = useStoreState(({ form }) => form.nationality?.value);

  if (nationality === CountryCodes.Jp && onboardOption?.value === 'signup') {
    return (
      <>
        <div data-testid="kana-names">
          <FullName
            firstName={countrySpecificFirstName}
            firstNameAriaDescribedBy={
              !countrySpecificFirstName?.displayError
                ? 'use-kana-names'
                : undefined
            }
            firstNameId="countrySpecificFirstName"
            labels={{
              firstName: getContent('fieldLabels.givenName'),
              lastName: getContent('fieldLabels.familyName'),
            }}
            lastName={countrySpecificLastName}
            lastNameAriaDescribedBy={
              !countrySpecificLastName?.displayError
                ? 'use-kana-names'
                : undefined
            }
            lastNameId="countrySpecificLastName"
            {...formInputHandlers}
          />
          <FullNameLabel id="use-kana-names" aria-hidden="true">
            {getContent('fieldLabels.useKanaNames')}
          </FullNameLabel>
        </div>

        <div data-testid="kanji-names">
          <FullName
            firstName={firstName}
            firstNameAriaDescribedBy={
              !firstName?.displayError ? 'use-kanji-names' : undefined
            }
            labels={{
              firstName: getContent('fieldLabels.givenName'),
              lastName: getContent('fieldLabels.familyName'),
            }}
            lastName={lastName}
            lastNameAriaDescribedBy={
              !lastName?.displayError ? 'use-kanji-names' : undefined
            }
            {...formInputHandlers}
          />

          <FullNameLabel id="use-kanji-names" aria-hidden="true">
            {getContent('fieldLabels.useKanjiNames')}
          </FullNameLabel>
        </div>
      </>
    );
  }

  return (
    <div data-testid="english-names">
      <FullName
        firstName={firstName}
        firstNameAriaDescribedBy={
          !firstName?.displayError ? 'use-english-names' : undefined
        }
        labels={{
          firstName: getContent('fieldLabels.givenName'),
          lastName: getContent('fieldLabels.familyName'),
        }}
        lastName={lastName}
        lastNameAriaDescribedBy={
          !lastName?.displayError ? 'use-english-names' : undefined
        }
        {...formInputHandlers}
      />

      <FullNameLabel id="use-english-names" aria-hidden="true">
        {getContent('fieldLabels.useEnglishNames')}
      </FullNameLabel>
    </div>
  );
};
